var map = {
	"../../modules/accounting/process/process.module": [
		"./src/app/modules/accounting/process/process.module.ts",
		"process.module"
	],
	"../../modules/magnetic-media-district/district-media-config/district-media-config.module": [
		"./src/app/modules/magnetic-media-district/district-media-config/district-media-config.module.ts",
		"common",
		"district-media-config.module"
	],
	"./balance-third/balance-third.module": [
		"./src/app/modules/accounting/balance-third/balance-third.module.ts",
		"balance-third.module"
	],
	"./modules/accounting/accounting.module": [
		"./src/app/modules/accounting/accounting.module.ts",
		"common"
	],
	"./modules/active-resume/active-resume.module": [
		"./src/app/modules/active-resume/active-resume.module.ts",
		"active-resume.module",
		"common"
	],
	"./modules/active-resume/unauth-active-resume/aprob.module": [
		"./src/app/modules/active-resume/unauth-active-resume/aprob.module.ts",
		"common",
		"aprob.module.0"
	],
	"./modules/admin/admin.module": [
		"./src/app/modules/admin/admin.module.ts",
		"common",
		"admin.module"
	],
	"./modules/admin/literals/literals.module": [
		"./src/app/modules/admin/literals/literals.module.ts",
		"common",
		"literals.module"
	],
	"./modules/auth/auth.module": [
		"./src/app/modules/auth/auth.module.ts",
		"auth.module"
	],
	"./modules/balance-history/balance-history.module": [
		"./src/app/modules/balance-history/balance-history.module.ts",
		"common",
		"balance-history.module"
	],
	"./modules/dashboard/dashboard.module": [
		"./src/app/modules/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./modules/documents/documents.module": [
		"./src/app/modules/documents/documents.module.ts",
		"common",
		"documents.module"
	],
	"./modules/magnetic-media-district/magnetic-media-district.module": [
		"./src/app/modules/magnetic-media-district/magnetic-media-district.module.ts",
		"magnetic-media-district.module"
	],
	"./modules/magnetic-media/magnetic-media.module": [
		"./src/app/modules/magnetic-media/magnetic-media.module.ts",
		"common",
		"magnetic-media.module"
	],
	"./modules/payment/payment.module": [
		"./src/app/modules/payment/payment.module.ts",
		"payment.module"
	],
	"./modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"profile.module"
	],
	"./modules/reception-advanced-doeq/aprob/aprob.module": [
		"./src/app/modules/reception-advanced-doeq/aprob/aprob.module.ts",
		"common",
		"aprob.module"
	],
	"./modules/reception-advanced-doeq/reception-advanced-doeq.module": [
		"./src/app/modules/reception-advanced-doeq/reception-advanced-doeq.module.ts",
		"common",
		"reception-advanced-doeq.module"
	],
	"./modules/reception-advanced/reception-advanced.module": [
		"./src/app/modules/reception-advanced/reception-advanced.module.ts",
		"common",
		"reception-advanced.module"
	],
	"./modules/rxsup/rxsup.module": [
		"./src/app/modules/rxsup/rxsup.module.ts",
		"common",
		"rxsup.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main